
import { Component, Mixins } from 'vue-property-decorator';
import OperationComponentMixin from '@/mixins/OperationComponentMixin.vue';

@Component
export default class OperationDogane extends Mixins(OperationComponentMixin) {
  get displayContent(): string | null {
    const raw = this.operationChild?.doganeElettricoNotes
      || this.operationChild?.gse
      || null;
    if (!raw) return null;
    return raw.replace(/<\/?p>/gi, '').trim() || null;
  }

  get columnClass(): string {
    const status = this.operationChild?.praticaDogane;
    if (status === 'na') return 'not-applicable';
    if (status === 'done') return 'completed';
    if (status === 'waiting') return 'warning';
    return '';
  }

  onEdit() {
    this.$emit('edit');
  }
}
